// Detecta se há alguma camada por cima da conversa (dialog/menu/popover do MUI
// ou o visualizador de imagens do react-modal-image). Essas camadas tratam o ESC
// sozinhas, então quem escuta ESC no nível da conversa precisa ignorar a tecla
// enquanto uma delas estiver aberta — senão o ESC fecharia as duas coisas.
//
// ATENÇÃO: não basta procurar o elemento no DOM. Menus com `keepMounted`
// (TicketOptionsMenu, ações rápidas do rodapé, ordenação da lista) ficam
// montados para sempre; o Modal do MUI v4 apenas aplica `visibility: hidden`
// inline no root quando fechado. Por isso a checagem é de visibilidade real —
// senão a tela de tickets teria "overlay aberto" o tempo todo.
const OVERLAY_SELECTORS = [
  ".MuiDialog-root",
  ".MuiPopover-root",
  ".__react_modal_image__modal_container",
].join(", ");

const isVisible = (el) => {
  // `display: none` não gera retângulos; `visibility: hidden` gera, então
  // precisa das duas checagens.
  if (el.getClientRects().length === 0) return false;
  return window.getComputedStyle(el).visibility !== "hidden";
};

const hasOpenOverlay = () =>
  Array.prototype.some.call(
    document.querySelectorAll(OVERLAY_SELECTORS),
    isVisible
  );

export default hasOpenOverlay;
